// React Query key prefixes for the SLOC lookups shown on the customer and container detail pages.
// Kept in their own module so the customer entity config can list them as invalidation
// dependencies (see entityConf.ts) without importing a component — editing a customer's SLOC API
// key then refreshes the validation result and SDM customer name.
export const SLOC_HAS_VALID_KEY_QUERY = "slocHasValidKey";
export const SLOC_CUSTOMER_HAS_KEY_QUERY = "customerHasSlocApiKey";
export const SLOC_CUSTOMER_NAME_QUERY = "slocCustomerName";
